module.exports = __webpack_public_path__ + "media/images/weather/10_night_g-1d77148077636e7c2e4cef7d675adcd5.png";